import { FormEvent, useEffect, useState } from "react";
import { LockKeyhole, Mail, QrCode, UserRound } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth";

export function AuthPage() {
  const { refresh } = useAuth();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") || "";
  const fromVehicleQr = next.startsWith("/inspecoes/nova/");
  const [needsSetup, setNeedsSetup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", email: "", identifier: "", password: "" });

  useEffect(() => {
    api<{ needs_setup: boolean }>("setup/status")
      .then((r) => setNeedsSetup(r.needs_setup))
      .finally(() => setLoading(false));
  }, []);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    try {
      await api(needsSetup ? "setup" : "login", {
        method: "POST",
        body: JSON.stringify(
          needsSetup
            ? { name: form.name, email: form.email, password: form.password }
            : { identifier: form.identifier, password: form.password }
        )
      });
      await refresh();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível entrar.");
    }
  }

  if (loading) return <div className="center-page">Carregando...</div>;

  return (
    <main className="auth-page">
      <div className="auth-decoration auth-decoration-a" />
      <div className="auth-decoration auth-decoration-b" />
      <section className="auth-card">
        <div className="auth-brand">
          <img src="/mm-logo.svg" alt="MM Locações" />
          <div className="auth-product-identity">
            <strong>MM Fleet</strong>
            <span>Gestão e Inspeção de Frota</span>
          </div>
        </div>
        <div className="auth-heading">
          {fromVehicleQr && (
            <div className="qr-login-note">
              <QrCode size={18} />
              <span>QR Code do veículo reconhecido. Entre para abrir a inspeção diretamente.</span>
            </div>
          )}
          <p className="eyebrow">GESTÃO E INSPEÇÃO DE FROTA</p>
          <h1>{needsSetup ? "Criar administrador inicial" : "Bem-vindo de volta"}</h1>
          <p>{needsSetup ? "Configure o primeiro acesso para iniciar a gestão da frota." : "Entre com e-mail e senha ou com seu usuário e PIN."}</p>
        </div>
        <form onSubmit={submit}>
          {needsSetup && (
            <label>
              Nome
              <div className="input-icon-wrap">
                <UserRound size={18} />
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              </div>
            </label>
          )}
          {needsSetup ? (
            <label>
              E-mail
              <div className="input-icon-wrap">
                <Mail size={18} />
                <input
                  required
                  type="email"
                  autoComplete="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
            </label>
          ) : (
            <label>
              E-mail ou usuário
              <div className="input-icon-wrap">
                <UserRound size={18} />
                <input
                  required
                  type="text"
                  autoCapitalize="none"
                  autoComplete="username"
                  placeholder="Ex.: nome@empresa.com ou cassio"
                  value={form.identifier}
                  onChange={(e) => setForm({ ...form, identifier: e.target.value })}
                />
              </div>
            </label>
          )}
          <label>
            {needsSetup ? "Senha" : "Senha ou PIN"}
            <div className="input-icon-wrap">
              <LockKeyhole size={18} />
              <input
                required
                minLength={needsSetup ? 8 : 6}
                type="password"
                autoComplete="current-password"
                inputMode={needsSetup ? undefined : "text"}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </div>
          </label>
          {error && <div className="alert error">{error}</div>}
          <button className="primary full auth-submit" type="submit">
            {needsSetup ? "Criar administrador" : "Entrar no sistema"}
          </button>
        </form>
        <div className="auth-footer">MM Locações · Qualidade, segurança e controle operacional</div>
      </section>
    </main>
  );
}
